import { DateField, TextField } from '@refinedev/antd';
import { Tag } from 'antd';
import { useTranslation } from 'react-i18next';

import { ShowInfoGrid, ShowInfoItem } from '@/components/general/ShowInfo/ShowInfo';
import { ShowSection } from '@/components/general/ShowInfo/ShowSection';
import { ServiceOrder } from '@/model/ServiceOrder/ServiceOrder';

// Acepta ServiceOrder completo o valores parciales de formulario con index signature
type TechnicianResponseData = Pick<
  ServiceOrder,
  | 'technician_confirmed'
  | 'technician_response'
  | 'technician_responded_at'
  | 'public_token_used_at'
>;

interface ServiceOrderShowTechnicianResponseProps {
  serviceOrder: TechnicianResponseData | (TechnicianResponseData & { [key: string]: unknown });
}

const ServiceOrderShowTechnicianResponse = (props: ServiceOrderShowTechnicianResponseProps) => {
  const { t } = useTranslation();
  const { serviceOrder } = props;
  const {
    technician_confirmed,
    technician_response,
    technician_responded_at,
    public_token_used_at,
  } = serviceOrder;

  if (!technician_responded_at && !public_token_used_at) {
    return null;
  }

  const statusTag = (() => {
    if (technician_confirmed === true) {
      return <Tag color="green">{t('Conforme')}</Tag>;
    }

    if (technician_confirmed === false) {
      return <Tag color="orange">{t('Solicita corrección')}</Tag>;
    }

    return <Tag color="default">{t('Link utilizado sin respuesta')}</Tag>;
  })();

  return (
    <ShowSection title={t('Respuesta del técnico')}>
      <ShowInfoGrid>
        <ShowInfoItem label={t('Estado')}>{statusTag}</ShowInfoItem>
        {technician_responded_at && (
          <ShowInfoItem label={t('Fecha de respuesta')}>
            <DateField value={technician_responded_at} format="LLL" />
          </ShowInfoItem>
        )}
        {technician_response && (
          <ShowInfoItem label={t('Observaciones')} colSpan={2}>
            <TextField value={technician_response} />
          </ShowInfoItem>
        )}
      </ShowInfoGrid>
    </ShowSection>
  );
};

export default ServiceOrderShowTechnicianResponse;
